export function openInternalResultTab(route) {
  if (!route) return;
  window.open(route, "_blank");
}
